import React, { useState } from "react";

const RatingStars = ({ totalStars = 5, onChange }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);

  const handleMouseEnter = index => {
    setHover(index + 1);
  };

  const handleMouseLeave = () => {
    setHover(0);
  };

  const handleClick = index => {
    setRating(index + 1);
    onChange(index + 1);
  };

  return (
    <div className="rating-stars">
      {[...Array(totalStars)].map((_, index) => (
        <span
          key={index}
          className={`star ${hover > index || rating > index ? "filled" : ""}`}
          onMouseEnter={() => handleMouseEnter(index)}
          onMouseLeave={handleMouseLeave}
          onClick={() => handleClick(index)}
        >
          ★
        </span>
      ))}
    </div>
  );
};

export default RatingStars;